import Header from './../Headers/HeaderForAreLoggedIn/index.vue'
import ProgressHUD from './../ProgressHUD/index.vue'
import Footer from './../Footers/Footer/index.vue'
import Cookie from './../Account/MyProfile/Widget/Cookie.vue'

export default {
  name: 'project',
  props: [],
  components: {
    Header,
    ProgressHUD,
    Footer,
    Cookie,
  },
  data() {
    return {
    }
  },
  async created() {
  },
}



// WEBPACK FOOTER //
// ./src/components/CookiePolicy/CookiePolicy.component.js